import React, { ReactNode, useEffect } from "react"
import { injectIntl } from "react-intl"
import SideBar from "../../common/layout/sidebar.component"
import Tabs from "../../common/layout/tabs.component"
import { INVENTORY_TAB, MainTabsProps } from "../../common/types/inventory"
import IntlProps from "../../state/helpers/IntlProps"
import { TAB_MESSAGES } from "../../utils/inventory"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"

export const MainTabs = injectIntl((props: MainTabsProps & IntlProps) => {
    useEffect(() => {
        SideBar.activateMenu("inventory")
    }, [])

    const tabs = (): Array<{name: ReactNode, link: string}> => {
        const tabs: Array<{name: ReactNode, link: string}> = []


        if (props.enabledOverride ?? AppContext.isInventoryEnabled()) {
            tabs.push({
                name: <span>{props.intl.formatMessage(TAB_MESSAGES[INVENTORY_TAB.STOCK_CONTROL])}</span>,
                link: "/inventory/stock-control"
            })
            tabs.push({
                name: <span>{props.intl.formatMessage(TAB_MESSAGES[INVENTORY_TAB.IMPORTS])}</span>,
                link: "/inventory/imports"
            })
            tabs.push({
                name: <span>{props.intl.formatMessage(TAB_MESSAGES[INVENTORY_TAB.STOCK_LOCATIONS])}</span>,
                link: "/inventory/stock-locations"
            })
            tabs.push({
                name: <span>{props.intl.formatMessage(TAB_MESSAGES[INVENTORY_TAB.DOCUMENT_TYPES])}</span>,
                link: "/inventory/document-types"
            })
        }

        tabs.push({
            name: <span>{props.intl.formatMessage(TAB_MESSAGES[INVENTORY_TAB.SETTINGS])}</span>,
            link: "/inventory/settings"
        })


        return tabs
    }

    return <Tabs value={tabs()}></Tabs>
})




// WEBPACK FOOTER //
// ./src/inventory/components/MainTabs.tsx